<template>
	<transition name='fade'>
		<div v-if='visiable' class="modal-container">
			<div class="model-dialog">
				<div class="modal-content">
					<div class="modal-header">
						<Icon class="close" type="md-close" @click="close" />
					</div>
					<div class="modal-body">
						<section class="page-header">
							<div class="container-fluid">
								<div class="row">
									<template v-if='payPv>=pc_pv_threshold'>
										<h3  class="title_en">Apply for preferred customer right now,<br>
											then you’ll enjoy the preferred customer discount immediately
										</h3>
										<h3 class="title">
											现在申请成为dōTERRA优惠顾客,<br>
											立即享有优惠顾客价格
										</h3>
									</template>
									<template v-else>
										<h3  class="title_en">Continue to chose products and apply for preferred customer,<br>
											then you’ll enjoy the preferred customer discount immediately
										</h3>
										<h3 class="title">
											继续选购产品，申请成为dōTERRA优惠顾客<br>
											立即享有优惠顾客价格
										</h3>
									</template>

								</div>
							
							</div>
						</section>

						<section>
							<div class="container-fluid">
								<div class="row">
									<Row>
										<Col class="cart-totals" :xs='12' :sm='12'>
										<div class="yourCart">
											目前您的购物车:
											<b class="mobile">Cart</b>
											
										</div>
										<div class="total-guest">零售顾客价格:&nbsp;&nbsp;
											<span>¥{{rtPrice.toFixed(2)}}</span>
										</div>
										<div class="total-guest_en">Retail customer price:
											<span>¥{{rtPrice.toFixed(2)}}</span>
										</div>
										<div class="total-member">优惠顾客价格:&nbsp;&nbsp;
											<span>¥{{pcPirce.toFixed(2)}}</span>
										</div>
										<div class="total-member_en">Preferred customer price:
											<span>¥{{pcPirce.toFixed(2)}}</span>
										</div>
										</Col>
										<Col :xs='12' :sm='6' :push='6' v-if='payPv>=pc_pv_threshold'>
										<div class="savings-circle">
											<p>立即&nbsp;</p>
											<p>节省:</p>
											<div>¥{{difference}}</div>
										</div>
										</Col>
									</Row>
								</div>
								<div class="account-benefits row">
									<Row>
										<Col class="list-member" :xs='12' :sm='12' :push='12'>
										<h4>
											<Icon class="pc" type="ios-star" />
											成为优惠顾客<b class="mobile">To be preferred customer</b>
											
										</h4>
										<ul>
											<li>
												<Icon class="mark" type="md-checkmark" />
												<span>以优惠顾客价格购买产品，尽享折扣<b>Purchase with preferred customer price and enjoy the discount</b></span>
											</li>
											<li>
												<Icon class="mark" type="md-checkmark" />
												<span>可加入忠诚顾客回馈计划，享有更多获得免费产品的机会<b>You can join the LRP Plan and enjoy more opportunities to get free products</b></span>
											</li>
											<!-- <li>
												<Icon class="mark" type="md-checkmark" />
												<span>每月装你最喜欢产品</span>
											</li>
											<li>
												<Icon class="mark" type="md-checkmark" />
												<span>接入门工具包(180元!)</span>
											</li> -->
										</ul>
										<p class="text-center">
											<!-- <a class="btn">注册会员</a> -->
											<template v-if='payPv>=pc_pv_threshold'>
												<Button class="btn autoheight" @click="register('pc')" type="primary" shape="circle">立即注册<br>Member register</Button>
											</template>
											<template v-else>
												<Button class="btn autoheight" @click="register()" type="primary" shape="circle">继续选购产品<br>Continue to chose products</Button>
											</template>

										</p>
										</Col>
										<Col class="list-guest" :xs='12' :sm='12' :pull='12'>
										<h4>
											<Icon class="rt" type="md-contact" />
											零售顾客<b class="mobile">Retail customer</b>
											
										</h4>
										<ul>
											<li>
												<Icon class="mark" type="md-checkmark" />
												<span>以零售价购买产品<b>Purchase with retail price</b></span>
											</li>
											<li>
												<Icon class="mark" type="md-checkmark" />
												<span>无其他优惠<b>No discount</b></span>
											</li>
										</ul>
										<p class="text-center">

											<Button class="btn autoheight" shape="circle" @click="register('rt')">继续<b>Continue</b></Button>
										</p>
										</Col>
									</Row>
								</div>
								<div class="text-center" v-if='!isCart'>
									已经是优惠顾客，点此直接<a @click="login">登陆</a>
								</div>
							</div>
						</section>

					</div>
				</div>
			</div>
		</div>
	</transition>

</template>

<script>
import { cvoUrl } from "@/config/env";
import { mapState, mapActions, mapMutations, mapGetters } from "vuex";
import {
	systemConfigMethods,
	cartInfoMethods
} from "@/components/common/mixin";
import { pc_pv_threshold } from '@/common/constant'
export default {
	props: {
		value: {
			type: Boolean,
			default: false
		},
		title: {
			type: String,
			default: ""
		},
		isCart: {
			type: Boolean,
			default: false
		}
	},
	data() {
		return {
			pc_pv_threshold,
			visiable: false
		};
	},

	created() {
		this.$nextTick(function() {
			this.initData();
		});
	},
	mounted() {},
	watch: {
		value(val) {
			//console.log("val", val);
			if (val) {
				//this.setCartTotal(this.baseDeliveryFee, this.baseServiceFee, 0);
			}
			this.visiable = val;
		}
	},
	mixins: [systemConfigMethods, cartInfoMethods],
	components: {},
	computed: {
		...mapGetters(["getAccessToken", "getVipNo"]),
		...mapState({
			sysConfig: state => state.common.sysConfig,
			cartInfo: state => state.order.cartInfo
		}),
		rtPrice() {
			let total_price = 0;
			if (this.shopCart[0]) {
				this.shopCart.forEach((item, index) => {
					total_price += item.rt_price * item.num;
				});
			}
			return total_price;
		},
		pcPirce() {
			let total_price = 0;
			if (this.shopCart[0]) {
				this.shopCart.forEach((item, index) => {
					total_price += item.pc_price * item.num;
				});
			}
			return total_price;
		},
		difference() {
			return (this.rtPrice - this.pcPirce).toFixed(2);
		}
	},
	methods: {
		...mapActions([]),
		...mapMutations(["SET_CART_TOTALRPT"]),
		async initData() {},
		close() {
			this.$emit("close");
		},
		login() {
			this.$emit("login");
		},
		register(type) {
			if (this.isCart) {
				if (type == "rt") {
					if (this.$route.path.toLowerCase() == '/order/cart') {
						this.$router.push({
							path: "/order/confirm"
						});
					} else {
						this.$router.push({
							path: "/order/cart"
						});
					}
					
				}
				else if (type == "pc") {
					location.href = `${cvoUrl}/vo/index.html#/enroll/appendPcInfo?token=${this.getAccessToken}&source=WebSite`;
				}
				else{
					this.$router.push("/order/product");
				}
			} else {
				if (type) {
					location.href = `${cvoUrl}/vo/index.html#/enroll/create?level=${type}&from=shop`;
					return;
				} else {
					this.$router.push("/order/product");
				}
			}
			this.$emit("close");
		},
		setCartTotal(delivery_fee, service_fee, ar_value) {
			this.SET_CART_TOTALRPT({ delivery_fee, service_fee, ar_value });
		}
	}
};
</script>

<style lang='scss' scoped>
@import "@/style/mixin";
@import "@/style/common";

@media screen and (min-width: 768px) {
	.modal-container .model-dialog {
		width: 700px;
	}
	.modal-container .modal-body {
		padding: 30px 25px 0;
	}
	.modal-container .account-benefits {
		margin: 10px -40px;
	}
}
@media screen and (min-width: 544px) {
	.modal-container .model-dialog {
		width: 700px;
		margin: 30px auto;
	}
	.modal-container .savings-circle {
		margin: 15px auto 0;
		position: relative;
		z-index: 11;
	}
	.modal-container .list-member {
		margin-top: -20px;
		box-shadow: -4px 0px 4px 0px #ccc;
		z-index: 10;
	}
}

.modal-container {
	position: fixed;
	top: 0;
	right: 0;
	bottom: 0;
	left: 0;
	z-index: 21050;
	background-color: rgba(0, 0, 0, 0.3);
	outline: 0;
	overflow-x: hidden;
	overflow-y: auto;
	padding-right: 16px;
}
.modal-content {
	position: relative;
	background-color: #fff;
	background-clip: padding-box;
	outline: 0;

	padding-bottom: 20px;
	box-shadow: 0 10px 20px 0 rgba(0, 0, 0, 0.18);
	border: none;
	border-top: 6px solid transparent;
	border-color: $theme-color;
	border-radius: 5px;
}
.modal-body {
	position: relative;
	padding: 30px 15px 0;
	padding-top: 0;
}

.modal-header {
	padding: 15px;
	border: none;
	padding-bottom: 0;
	padding-left: 30px;
	background-color: #fff;
	height: 55px;
	.close {
		color: #354657;
		float: right;
		font-size: 22px;
		cursor: pointer;
	}
}
.model-dialog {
	position: relative;
	width: auto;
	margin: 10px;
	top: 2vh;
}
.modal-body {
	section {
		display: table;
		width: 100%;
		margin-bottom: 15px;
	}
}
.page-header {
}
.container-fluid {
	margin-right: auto;
	margin-left: auto;
	padding-left: 15px;
	padding-right: 15px;
}
.row {
	margin-left: -15px;
	margin-right: -15px;
}
.row:before,
.row:after {
	content: " ";
	display: table;
}
.row:after {
	clear: both;
}
.title {
	font-size: 18px;
	text-align: center;
}
.title_en {
	font-size: 18px;
	text-align: center;
	margin-bottom: 10px;
}
.cart-totals {
	text-align: center;
	padding-top: 25px;
	font-size: 16px;
	& > div {
		margin-bottom: 5px;
	}
	.yourCart {
		font-weight: bold;
		text-emphasis: center;
	}
}
.total-member {
	span {
		color: $theme-color;
		font-weight: bold;
	}
}
.total-member_en {
	span {
		color: $theme-color;
		font-weight: bold;
	}
}
.savings-circle {
	position: relative;
	top: 70px;
	padding-top: 25px;
	margin: 0 auto;
	color: #fff;
	background-color: $theme-color;
	width: 110px;
	height: 110px;
	border-radius: 55px;
	box-shadow: 3px 3px 15px 0px #999;
	line-height: 1;
	text-align: center;
	& > div {
		margin-top: 4px;
		font-size: 18px;
		font-weight: bold;
	}
	& > p {
		font-size: 16px;
		margin-bottom: 8px;
	}
}
.account-benefits {
	margin: 10px -30px;
	& > div {
	}
	h4 {
		margin: 20px 0 15px;
		font-size: 16px;
		font-weight: bold;
		color: #333;
		text-align: center;
		display: flex;
		align-items: center;
		flex-flow: column;
	}
	ul {
		list-style: none;
		padding: 0;
	}
	li {
		padding-left: 2.4em;
		line-height: 1.4;
		margin-bottom: 20px;
		display: flex;
		align-items: center;
		& > span {
			b{
				font-weight: 500;
			}
		}
	}
}
.pc {
	color: $theme-color;
	font-size: 50px;
	margin-bottom: 10px;
}
.rt {
	font-size: 50px;
	margin-bottom: 10px;
}
.mark {
	//width: 60px;
	font-size: 25px;
	padding-right: 15px;
}
.list-member {
	padding: 10px 30px 20px;
	font-size: 14px;
	background: #f5eef7;
	ul {
		margin-left: 20px;
	}
	.mark {
		color: $theme-color;
	}
}
.list-guest {
	padding: 10px 30px 20px;
	font-size: 14px;
	background: #f4f8fd;
	li {
		padding-left: 4.4em;
	}
}
p.text-center {
	margin: 0 0 24px;
}
.text-center {
	text-align: center;
	a {
		text-decoration-line: underline;
		padding-left: 10px;
		//margin-top: 5px;
		color: $theme-color;
		&:hover {
			text-decoration-line: underline;
		}
	}
}
.btn {
	font-size: 16px;
	padding: 5px 20px;
	b {
		display: block;
		font-weight: 500;
	}
}
.mobile{
	display: block;
}

.fade-enter-active,
.fade-leave-active {
	transition: opacity 0.5s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
	opacity: 0;
}
@media (max-width: 768px) {
.modal-container{
		padding-right:0px;
	}
	.mobile{
		display: none;
	}
	.title_en{
		display: none;
	}
	.total-guest_en{
		display: none;
	}
	.total-member_en{
		display: none;
	}
	.savings-circle{
	margin: 0;
	z-index: 9;
	right: 1.5rem;
}
.list-guest{
	padding: 0;
	li{
		padding-left: 5px;
		b{
			display: none;
		}
	}
}
.list-member{
	padding: 0;
	li{
		padding-left: 0;
		b{
			display: none;
		}
	}
}
}


</style>